/* eslint-disable @typescript-eslint/naming-convention */
import { AnyStateJS } from "./../stateJS/AnyStateJS";
import { FormStateJS } from "./../stateJS/FormStateJS";
import { ListStateJS } from "../stateJS/ListStateJS";
import { RvListStateJS } from "../stateJS/RvListStateJS";
import { AnyState } from "./AnyState";
import { FormState } from "./FormState";
import { ListState } from "./ListState";
import { getCollection } from "../collection/getCollection";
import { isJSStateModel } from "../common/getStateModels";
import { RvFormStateJS } from "../stateJS/RvFormStateJS";
const stateCtorMap = {
  list: ListState,
  form: FormState,
  any: AnyState,
  list_JS: ListStateJS,
  form_JS: FormStateJS,
  any_JS: AnyStateJS,
  rv_list_JS: RvListStateJS,
  rv_form_JS: RvFormStateJS
};
/**
 * 只支持新数据源模型
 * @param options
 * @returns
 */
export function getCollectionStateSync(options) {
  var _options$stateInitOpt, _options$stateInitOpt2;
  const isSync = isJSStateModel(options.stateModel) && (((_options$stateInitOpt = options.stateInitOptions) === null || _options$stateInitOpt === void 0 || (_options$stateInitOpt = _options$stateInitOpt.extraConfig) === null || _options$stateInitOpt === void 0 ? void 0 : _options$stateInitOpt.sync) || ((_options$stateInitOpt2 = options.stateInitOptions) === null || _options$stateInitOpt2 === void 0 || (_options$stateInitOpt2 = _options$stateInitOpt2.sourceConfig) === null || _options$stateInitOpt2 === void 0 ? void 0 : _options$stateInitOpt2.sync));
  if (!isSync) {
    throw new Error('模型参数错误');
  }
  if (!options.stateModel) {
    throw new Error('没有选择模型');
  }
  const StateCtor = stateCtorMap[options.stateModel];
  if (!options.stateModel) {
    throw new Error(`找不到 ${options.stateModel} 模板对应的数据管理层`);
  }
  const get = async () => {
    var _options$stateInitOpt3, _options$stateInitOpt4;
    const collection = await getCollection({
      collectionId: options.collectionId,
      projectId: options.projectId,
      pageId: options.pageId,
      envId: options.envId,
      getDynamicParamValues: (_options$stateInitOpt3 = options.stateInitOptions) === null || _options$stateInitOpt3 === void 0 ? void 0 : _options$stateInitOpt3.getDynamicParamValues,
      useCache: options.collectionCache,
      useOrInsteadOfIn: (_options$stateInitOpt4 = options.stateInitOptions) === null || _options$stateInitOpt4 === void 0 || (_options$stateInitOpt4 = _options$stateInitOpt4.sourceConfig) === null || _options$stateInitOpt4 === void 0 ? void 0 : _options$stateInitOpt4.useOrInsteadOfIn,
      simplifyCgiSchema: shouldSimplifyCgiSchema(options)
    });
    return collection;
  };
  return {
    stateCtor: StateCtor,
    state: new StateCtor(null, {
      ...options.stateInitOptions,
      getCollection: get
    })
  };
}
/**
 * 异步获取数据源
 * @param options
 * @returns
 */
export async function getCollectionState(options) {
  var _options$stateInitOpt5, _options$stateInitOpt6;
  const collection = await getCollection({
    collectionId: options.collectionId,
    projectId: options.projectId,
    pageId: options.pageId,
    envId: options.envId,
    getDynamicParamValues: (_options$stateInitOpt5 = options.stateInitOptions) === null || _options$stateInitOpt5 === void 0 ? void 0 : _options$stateInitOpt5.getDynamicParamValues,
    useCache: options.collectionCache,
    useOrInsteadOfIn: (_options$stateInitOpt6 = options.stateInitOptions) === null || _options$stateInitOpt6 === void 0 || (_options$stateInitOpt6 = _options$stateInitOpt6.sourceConfig) === null || _options$stateInitOpt6 === void 0 ? void 0 : _options$stateInitOpt6.useOrInsteadOfIn,
    simplifyCgiSchema: shouldSimplifyCgiSchema(options)
  });
  const data = collection.collectionData;
  // 如果 ly那边的配置有指明用哪一种state ，这里就优先取用户指明的类型，不然走兼容的模板的类型
  let StateCtor = stateCtorMap[options.stateModel || data.tplType];
  const stateModels = collection.getStateModels();
  if (!StateCtor) {
    if (stateModels.length) {
      StateCtor = stateCtorMap[stateModels[0]];
    } else {
      throw new Error(`找不到 ${data.tplType} 模板对应的数据管理层`);
    }
  }
  return {
    stateCtor: StateCtor,
    state: new StateCtor(collection, options.stateInitOptions || {})
  };
}
function shouldSimplifyCgiSchema(options) {
  var _options$stateInitOpt7;
  const model = (_options$stateInitOpt7 = options.stateInitOptions) === null || _options$stateInitOpt7 === void 0 || (_options$stateInitOpt7 = _options$stateInitOpt7.sourceConfig) === null || _options$stateInitOpt7 === void 0 ? void 0 : _options$stateInitOpt7.stateModel;
  const isJSModel = !!model && isJSStateModel(model);
  return isJSModel;
}
//# sourceMappingURL=getCollectionState.js.map
